import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Clock, Calendar, User } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { fileUrl } from "../uploads";

export default function ArticuloDetalle() {
  const { id } = useParams();
  const { articles } = useStore();
  const article = articles.find((a) => a.id === id);

  if (!article) {
    return (
      <div className="max-w-3xl mx-auto px-5 py-24 text-center">
        <h1 className="font-serif text-3xl text-plum">Artículo no encontrado</h1>
        <Link to="/articulos" className="font-sans text-terracotta mt-4 inline-block">
          Volver a artículos
        </Link>
      </div>
    );
  }

  const related = articles.filter((a) => a.stage === article.stage && a.id !== article.id).slice(0, 2);

  return (
    <div className="animate-fade-in">
      <div className="relative h-[42vh] min-h-[320px] overflow-hidden">
        <img src={fileUrl(article.cover)} alt={article.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/40 to-ink/20" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-3xl mx-auto px-5 lg:px-8 pb-10 w-full">
            <span className="font-sans text-xs uppercase tracking-[0.2em] text-amber">
              {article.stage}
            </span>
            <h1 className="font-serif text-4xl md:text-5xl text-cream mt-2 leading-tight">
              {article.title}
            </h1>
          </div>
        </div>
      </div>

      <article className="max-w-3xl mx-auto px-5 lg:px-8 py-12">
        <Link
          to="/articulos"
          className="inline-flex items-center gap-2 font-sans text-sm text-plum hover:text-terracotta transition-colors mb-8"
        >
          <ArrowLeft size={16} /> Volver a artículos
        </Link>

        <div className="flex flex-wrap gap-5 text-sm font-body text-ink/55 border-b border-amber/40 pb-6 mb-8">
          <span className="flex items-center gap-1.5"><User size={15} className="text-terracotta" /> {article.author}</span>
          <span className="flex items-center gap-1.5"><Calendar size={15} className="text-terracotta" /> {article.date}</span>
          <span className="flex items-center gap-1.5"><Clock size={15} className="text-terracotta" /> {article.readTime} min de lectura</span>
        </div>

        {/^\s*<[a-z]/i.test(article.content || "") ? (
          <div
            className="rte-content font-body text-lg text-ink/80 leading-[1.85] space-y-5"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />
        ) : (
          <div className="font-body text-lg text-ink/80 leading-[1.85] space-y-5">
            {(article.content || "").split("\n\n").map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        )}

        <div className="mt-12 bg-amber/25 rounded-2xl p-7 text-center">
          <h3 className="font-serif text-2xl text-plum">¿Quieres profundizar más?</h3>
          <p className="font-body text-ink/65 mt-2">
            Accede a cursos, foros y sesiones grupales uniéndote a la comunidad.
          </p>
          <Link
            to="/membresia"
            className="inline-block mt-5 bg-plum text-cream font-sans px-7 py-3 rounded-full hover:bg-[#684d89] transition-colors"
          >
            Ver membresía
          </Link>
        </div>
      </article>

      {related.length > 0 && (
        <section className="max-w-5xl mx-auto px-5 lg:px-8 pb-20">
          <h3 className="font-serif text-3xl text-plum mb-7">También te puede interesar</h3>
          <div className="grid md:grid-cols-2 gap-6">
            {related.map((a) => (
              <Link
                key={a.id}
                to={`/articulos/${a.id}`}
                className="group flex gap-4 bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all"
              >
                <img src={fileUrl(a.cover)} alt={a.title} className="w-32 h-32 object-cover" />
                <div className="py-4 pr-4">
                  <span className="font-sans text-[10px] uppercase tracking-[0.15em] text-terracotta">{a.stage}</span>
                  <h4 className="font-serif text-xl text-plum mt-1 leading-tight group-hover:text-terracotta transition-colors">{a.title}</h4>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
